module.exports = __webpack_public_path__ + "img/logo_cms.023caf74.jpg";